import { render, staticRenderFns } from "./review-appendix.vue?vue&type=template&id=7b24d310"
import script from "./review-appendix.vue?vue&type=script&lang=js"
export * from "./review-appendix.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports